import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../ui/Logo";
import { ItalianFlag } from "../ui/ItalianFlag";

export function Topbar({ onMenuClick }: { onMenuClick: () => void }) {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="relative z-30 h-16 flex items-center justify-between px-4 md:px-6 border-b border-surface-border bg-surface-card/90 bg-carbon backdrop-blur">
      <div className="flex items-center gap-3">
        <button onClick={onMenuClick} className="md:hidden text-gray-300 text-xl leading-none px-1" aria-label="Menü öffnen">
          ☰
        </button>
        <div className="md:hidden flex items-center gap-2">
          <Logo className="h-7 w-auto" />
          <span className="font-display font-semibold text-gray-100 uppercase tracking-wide text-sm">Phantom of Hell</span>
        </div>
        <div className="hidden md:block text-sm text-gray-500">
          {new Date().toLocaleDateString("de-DE", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
        </div>
      </div>

      <div className="relative">
        <button
          onClick={() => setMenuOpen((o) => !o)}
          className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-surface-raised transition-colors"
        >
          {user?.username === "fratellis" ? (
            <ItalianFlag className="h-5 w-8" />
          ) : (
            <div className="w-8 h-8 rounded-full bg-accent-muted text-accent flex items-center justify-center text-sm font-semibold">
              {user?.fullName?.charAt(0).toUpperCase()}
            </div>
          )}
          <div className="hidden sm:block text-left">
            <p className="text-sm font-medium text-gray-200 leading-tight">{user?.fullName}</p>
            <p className="text-xs text-gray-500 leading-tight">{user?.roleName}</p>
          </div>
        </button>

        {menuOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setMenuOpen(false)} />
            <div className="absolute right-0 mt-2 w-48 card p-1.5 z-20">
              <button
                onClick={() => { setMenuOpen(false); navigate("/profile"); }}
                className="w-full text-left px-3 py-2 rounded-lg text-sm text-gray-300 hover:bg-surface-raised"
              >
                Mein Profil
              </button>
              <button
                onClick={logout}
                className="w-full text-left px-3 py-2 rounded-lg text-sm text-danger hover:bg-danger-muted"
              >
                Abmelden
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
